export const getstudentregistrtionlist = (state = [], action) => {
  switch (action.type) {
    case "GET_STD_REGSTR_DATA":
      return action.payload.data;
    default:
      return state;
  }
};

export const getUserWiseAppCount = (state = [], action) => {
  switch (action.type) {
    case "GET_USERWISE_APP_REG_COUNT":
      return action.payload;
    default:
      return state;
  }
};
